import MatchSuggestionsModal from "@/components/cash/MatchSuggestionsModal";
import MarkAsModal from "@/components/cash/MarkAsModal";
import type { Transaction } from "@/types/payments";
import type { useTransactionMatching } from "@/hooks/useTransactionMatching";
import type { TransactionDialogsState } from "@/hooks/useTransactionDialogs";

type MatchingHandlers = Pick<
  ReturnType<typeof useTransactionMatching>,
  "handleMatchSelection" | "handleConfirmPayableMatch" | "handleConfirmOwnAccountMatch"
>;

interface TransactionMatchDialogsProps {
  transaction: Transaction | null;
  dialogs: TransactionDialogsState;
  matching: MatchingHandlers;
  formatCurrency: (amount: number, currency: string) => string;
}

/** The two dialogs a transaction row opens, shared by the Bank and Transactions pages. */
export function TransactionMatchDialogs({ transaction, dialogs, matching, formatCurrency }: TransactionMatchDialogsProps) {
  return (
    <>
      <MatchSuggestionsModal
        open={dialogs.matchOpen}
        setOpen={dialogs.setMatchOpen}
        transaction={transaction}
        handleConfirmMatch={matching.handleMatchSelection}
        onConfirmPayableMatch={matching.handleConfirmPayableMatch}
        onConfirmOwnAccountMatch={matching.handleConfirmOwnAccountMatch}
        formatCurrency={formatCurrency}
      />

      <MarkAsModal
        open={dialogs.markAsOpen}
        setOpen={dialogs.setMarkAsOpen}
        transaction={transaction}
        formatCurrency={formatCurrency}
      />
    </>
  );
}
